import { SetStateAction } from "react";
import { stdObject } from "../../../data/types/stdObject";
import {
  occasionalCustomerField,
  occasionalResField,
} from "../../../data/main";
import { checkOccasionalCustomer } from "../functions/document/openCasualPerson";
import { colors } from "../../../data/colors";

export const occasionalModal = ({
  t,
  docData,
  windowValues,
  updateDocData,
  setWindowValues,
  setMsg2,
  setDocValues,
  setModalData2,
  closeMsg,
  logoutAction,
}: stdObject) => {
  return {
    title: windowValues.title ?? "",
    inputs:
      windowValues.occasionalData &&
      (windowValues.occCode === "RES"
        ? occasionalResField
        : occasionalCustomerField
      ).map((e: string, index: number) => {
        return {
          label: ["CLI", "RES"].includes(e) ? t(`c.COD`) : t(`c.${e}`),
          value: windowValues.occasionalData
            ? windowValues.occasionalData[index]
            : "",
          type: "text",
          style: { width: 300 },
          onChange: (v: { target: { value: SetStateAction<string> } }) => {
            windowValues.occasionalData[index] = v.target.value;
            setWindowValues({ ...windowValues });
          },
        };
      }),
    buttons: [
      {
        label: t("p.update"),
        onClick: () =>
          checkOccasionalCustomer({
            t,
            docData,
            windowValues,
            updateDocData,
            setMsg2,
            setDocValues,
            setModalData2,
            setWindowValues,
            closeMsg,
            logoutAction,
          }),
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: () => {
          closeMsg(windowValues.level);
          setWindowValues({});
        },
        color: colors.darkGrey,
      },
    ],
  };
};
